// @flow

import type { Tracker } from './combine'

let ga
let type = 'react-app'

export default function (id?: string = 'UA-89061742-2'): Tracker {
  const tracker: Tracker = {
    init () {
      /* eslint-disable */
      eval(`(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');`);
      /* eslint-enable */
      ga = window.ga
      ga('create', id, 'auto')
      ga('send', 'pageview')
    },

    trackPageview (page?: string, prePage?: string) {
      ga('set', 'page', page)
      ga('send', 'pageview')
    },

    trackEvent (name: string): void {
      ga('send', 'event', type, 'set_value', name)
    },

    trackEventValue (name: string, value: string | {}) {
      if (typeof value === 'string') {
        ga('send', 'event', type, 'set_value', name, value)
      }
    },

    setUid (uid: string) {},

    setCustomVar (key: string, value: string) {
      let gaIndexMap = {
        channel: 1,
        browserEnv: 2,
        isLogin: 3
      }
      if (gaIndexMap[key]) {
        ga('set', 'dimension' + gaIndexMap[key], value)
      }
    }
  }
  return tracker
}



// WEBPACK FOOTER //
// ./src/frame/core/analysis/ga.js